export const lightenColor = (color, percent) => {
    let r;
    let g;
    let b;
    let a = 1;
    if (color.startsWith('#')) {
        let hex = color.replace('#', '');
        if (hex.length === 3 && hex.match(/[0-9A-Fa-f]{3}/)) {
            hex = hex
                .split('')
                .map(char => char + char)
                .join('');
        }
        if (hex.length !== 6)
            throw new Error('Invalid HEX color.');
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    }
    else if (color.startsWith('rgba')) {
        const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (!rgbaMatch)
            throw new Error('Invalid RGBA color format.');
        [r, g, b, a] = rgbaMatch.slice(1).map(Number);
    }
    else if (color.startsWith('rgb')) {
        const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
        if (!rgbMatch)
            throw new Error('Invalid RGB color format.');
        [r, g, b] = rgbMatch.slice(1).map(Number);
    }
    else {
        throw new Error('Invalid color format. Accepted formats are HEX, RGB, and RGBA.');
    }
    const lighten = (component) => Math.min(255, Math.floor(component + (255 - component) * (percent / 100)));
    r = lighten(r);
    g = lighten(g);
    b = lighten(b);
    return a < 1 ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`;
};
//# sourceMappingURL=lightenColor.js.map